module.exports = __webpack_public_path__ + "static/media/ArrowLeft.0588ab5e.svg";